<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/190315-feature-pic.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">研究证实NIPT检测范围扩展至染色体微片段缺失重复是临床迫切的需求</div>
                   <div class="post_info">Posted at 09:00h in 无创产前检测</div>
                    <div class="post_tip_1" style="margin-top:0px !important;">
                       非侵入性产前检测（NIPT）渐渐成为主流产前检测，原因是其技术的提升以及可减少产检过程可能对孕妇造成的负担。随着临床数据的不断累积和分析技术的精进，未来NIPT相关的临床应用也势必更加广泛。除了一般常见的染色体异常（T21，T18，T13）外，性染色体异常（X0，XXX，XXY，XYY）、染色体微片段缺失/重复综合征、罕见的单基因遗传疾病（例如：海洋性贫血和脊髓性肌肉萎缩症）等都可能成为非侵入性产检的标准筛检项目，这也将会是孕妇与胎儿的一大福音。
                    </div>
                    <div class="post_wrapper_1">
                      国际权威学术期刊《Nature》子刊《Genetics in Medicine》最近发表了一篇题为《无创产前检测在染色体疾病扩展性筛查中的临床效用》的文章，由中南大学生命科学学院医学遗传学研究中心、湖南家辉遗传专科医院、湖南省妇幼保健院和贝勒医学院分子与人类遗传学系合作发表，该研究证实NIPT可作为产前一级筛查方法。
                    </div>
                  
                    <div class="post_wrapper_tip">1．实验背景</div>
                    <div class="post_wrapper_1">
                        与一般常见的染色体异常，染色体微片段缺失/重复综合征也会导致先天性畸形、器官功能障碍、生长发育迟缓、智力残疾、自闭症等，占新生儿先天性异常的1-2%，给家庭和社会带来严重的经济和精神负担。据有关研究表明，在染色体异常出现中排名前11位的包括：T21、22q11.2缺失综合征、Cystic Fibrosis、T18、T13、Fragile X、1p36缺失综合征、SMA、Prader-Willi综合征、Angelman综合征、Cri du Chat 综合征。22q11.2缺失综合征的发生率排第二，仅次于T21。在这前11位染色体异常中，有5种是染色体微片段缺失/重复综合征。
                    </div>
                      <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190315-gene-copy.jpg"/>
                        <div class="bottom_tip">随着临床数据的不断累积和分析技术的精进，非侵入性产前检测（NIPT）的临床应用未来势必更加广泛，这也将会是孕妇与胎儿的一大福音。</div>
                    </div> 
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190315-gene-cnv.jpg"/>
                        <div class="bottom_tip">随着临床数据的不断累积和分析技术的精进，非侵入性产前检测（NIPT）的临床应用未来势必更加广泛，这也将会是孕妇与胎儿的一大福音。</div>
                    </div>
                    
                    <div class="post_wrapper_1 margin_top">
                        根据美国医学遗传学和基因组学学会（ACMG）最近的指南，专家普遍认为在大规模人群研究证实扩展性无创产前筛查的临床表现之前就将其应用于临床是不合适的。为了解决上述问题，研究团队设计开发了新一种NIPT的流程，拥有更深的测序深度，并使用组合资料分析演算法来另行读取与染色体微片段缺失/重复综合征相关的全基因组。
                    </div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190315-gene-microdelete.jpg"/>
                        <div class="bottom_tip">随着临床数据的不断累积和分析技术的精进，非侵入性产前检测（NIPT）的临床应用未来势必更加广泛，这也将会是孕妇与胎儿的一大福音。</div>
                    </div>
                    <div class="post_wrapper_tip">2．实验方法</div>
                    <div class="post_wrapper_1">
                       该研究招募了94,085名单胎妊娠女性并对胎儿异常进行前瞻性研究，以无创产前筛查评估染色体非整倍体和全基因组微缺失/微重复综合征在检测中的临床表现。母血胎儿游离DNA经PCR-free建库，经Next generation sequencing测序，使用经改进的复制数变异（CNV）对胎儿异常进行检测分析。
                    </div>
                    <div class="post_wrapper_tip">3．样本设计</div>
                    <div class="post_wrapper_1">
                        <ul>
                            <li>38,023名高危妊娠（40.41％），孕妇年龄≥35岁（中位数37岁，范围35-53岁）</li>
                            <li>56,058名低危妊娠（59.58％），孕妇年龄&lt;35岁（中位数29岁，范围15-34岁）</li>
                            <li>4名（0.004％）孕妇年龄不详。 </li>
                        </ul>
                    </div>
                    <div class="post_wrapper_2">
                        除了31名胎龄未知和23例胎龄不到11周的样本外，血样采集于胎龄的11周到39周（中位数为17周），经校对后的胎儿DNA含量中位数为10.8 %。
                    </div>
                    <div class="post_wrapper_tip">4．实验结果</div>
                    <div class="post_wrapper_1">
                      共计1128名（1.2%）具有临床意义的胎儿染色体异常的阳性结果，包括965名染色体非整倍体（1.026%）和163名染色体微片段缺失/重复（0.174%）。通过随机检验，T21、T18、T13的阳性出现率分别为95%、82%、46%，DiGeorge综合征的阳性出现率高达93%。
                    </div>
                     <div class="post_wrapper_1">
                      测试结果证实，非整倍体和DiGeorge综合征具有较高的阳性出现率，其他染色体微片段缺失/重复具也有中度阳性出现率。相对其他筛查方法，NIPT有较高的敏感度和准确度，亦是一种有较高胎儿染色体异常检测率的检测方法。
                    </div>
                    <div class="post_wrapper_tip">5．结论</div>
                    <div class="post_wrapper_1">
                      目前NIPT用于检测常见的胎儿常染色体三体综合征和性染色体非整倍体，已经被临床医生和患者广泛接受，但仍然要继续提高对检测染色体微片段缺失/重复综合征和其他罕见染色体疾病综合征的水准。
                    </div>
                     <div class="post_wrapper_1">
                      以上研究通过一群单胎妊娠女性（共94,085名）利用非侵入性产前检测（NIPT）进行评估，证实其检测在染色体微缺失和重复时表现出高灵敏度和特异性，同时对检测常见的非整倍体也有非常高的灵敏度和特异性。
                    </div>
                    <div class="post_wrapper_1">
                      这是首个包括高危和低危妊娠等的大规模孕妇群体的研究。只要将非侵入性产前检测（NIPT）与超声波检查结合，必定大大提高临床显著胎儿染色体异常的检出率。
                    </div>
                    <div class="post_wrapper_1">
                        參考資料：<a href="https://www.nature.com/articles/s41436-019-0467-4">
                        Clinical utility of noninvasive prenatal screening for expanded chromosome disease syndromes </a>
                    </div>
                    
               </div>
           </div>
           <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    margin-bottom:25px;
    
    font-family: 'Microsoft JhengHei',sans-serif !important;
      margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:15px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    ul{
                            list-style-position: inside;
                            display: block;
                            list-style-type: disc;
                            margin-block-start: 1em;
                            margin-block-end: 1em;
                            margin-inline-start: 0px;
                            margin-inline-end: 0px;
                            padding-inline-start: 40px;
                    }
                    li{
                        display: list-item;
                        text-align: -webkit-match-parent;
                    }
                }
                .post_wrapper_2{
                     margin-top:3px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_tip_c{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    margin-top:10px;
                    letter-spacing: .07em!important;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
                .margin_top{
                    margin-top:35px;
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/genssix.vue